import React, { useRef, useState, useEffect } from 'react';
import { Row, Col, InputGroup } from 'react-bootstrap';

const NoticeTile = ({ notice, aggregateTypeChoice, selectedEntity = 0, handleEntitySelect }) => {
	const titleRef = useRef(null);
	const descRef = useRef(null);
	const [isTextLong, setIsTextLong] = useState(false);
	const [expanded, setExpanded] = useState(false);

	useEffect(() => {
		if (titleRef.current && descRef.current) {
			const lineHeightD = parseFloat(getComputedStyle(descRef.current).lineHeight);
			const heightD = descRef.current.scrollHeight;
			const linesD = Math.round(heightD / lineHeightD);

			const lineHeightT = parseFloat(getComputedStyle(titleRef.current).lineHeight);
			const heightT = titleRef.current.scrollHeight;
			const linesT = Math.round(heightT / lineHeightT);

			setIsTextLong(linesD > 2 || linesT > 2);
		}
	}, [notice.noticeName, notice.noticeCall]);

	return (
		<Col className="px-0 py-3">
			<InputGroup className={`aggregate-notice-radio-group ${selectedEntity === notice.noticeId ? 'checked-aggregate' : ''}`}>
				<InputGroup.Radio
					className="col-1"
					id={`notice-${notice.noticeId}`}
					name={`${aggregateTypeChoice}-checklist`}
					value={`notice-${notice.noticeId}`}
					checked={selectedEntity === notice.noticeId}
					onChange={(e) => handleEntitySelect(e, aggregateTypeChoice, notice.noticeId, e.target.checked)}
				/>
				<InputGroup.Text className="col-11 text-start p-2 pt-0" style={{ whiteSpace: 'normal' }}>
					<Row className="flex-column">
						<Col className="py-3 d-flex flex-column justify-content-end" style={{ minHeight: '56px' }}>
							<span ref={titleRef} className={`pe-0 tile-title${expanded ? ' expanded' : ''}`}>
								{notice.noticeCall}
							</span>
							<span
								ref={descRef}
								className={`tile-details${expanded ? ' expanded' : ''}`}
								style={expanded ? { WebkitLineClamp: 'unset', minHeight: '48px', maxHeight: 'none' } : {}}
							>
								{notice.noticeName ?? '-'}
							</span>
						</Col>
						{isTextLong && (
							<Col
								className="col-auto mt-1 mx-2 px-0"
								style={{ borderTop: '1px solid #C7CFD7' }}
								onClick={() => setExpanded((prev) => !prev)}
							>
								<div className="title-link new-text-as-link">
									mostra di {expanded ? 'meno' : 'più'}
									<span className={`svg-arrow${expanded ? ' rotated' : ''}`}></span>
								</div>
							</Col>
						)}
					</Row>
				</InputGroup.Text>
			</InputGroup>
		</Col>
	);
};

export default NoticeTile;
